<template>
  <div v-if="value"
    class="new-user-wrapper"
    id="NewUserToast"
  >
    <div class="new-user">
      <div v-if="className=='homeToast'" class="swiper-wrappper">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) in swiperData" :key='index'>
            <img :src="item.img">
          </swiper-slide>
          <div
            v-if="swiperData.length>1"
            class="swiper-pagination"
            slot="pagination"
          >
          </div>
        </swiper>
        <div class="openvip" @click="openVip"></div>
      </div>
      <div class="close" @click="handleClickClose"><img src="./static/close.png"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reportPay } from '@/libs/utils/log/log';

export default {
  data() {
    return {
      swiperOption: {
        pagination: { el: '.swiper-pagination' },
        preventLinksPropagation: false,
        watchOverflow: true,
        autoplay: { disableOnInteraction: false },
      },
      swiperData: [
        { img: 'https://qncweb-back1.ktvsky.com/20210607/vadd/babbedb7183347ad27ee749c149bdda4.png' },
        { img: 'https://qncweb-back1.ktvsky.com/20210607/vadd/bd1e892833ea3c97ce0c9a909c68ea72.png' },
        { img: 'https://qncweb-back1.ktvsky.com/20210607/vadd/44ac1d12ae77952d41a5e516768d7bb5.png' },
        { img: 'https://qncweb-back1.ktvsky.com/20210607/vadd/50b7a6fb12f845bbe8b739d508e1205b.png' },
      ],
      value: false,
      className: '',
      enterTime: 0,
      page_tp: 'new1dayvip',
    };
  },
  computed: {
    ...mapState({
      is_vip: (state) => state.is_vip,
      bless_path: (state) => state.bless_path,
      photo_path: (state) => state.photo_path,
    }),
  },
  methods: {
    handleClickClose() {
      this.$RaiseMessage.close(true);
    },
    handlePageUnload() {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 1, // 用户行为：0：点击 ;1：停留
        stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
      });
    },
    openVip() {
      this.buyVipPlus();
      reportPay({
        page_tp: this.page_tp,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
    },
  },
  async mounted() {
    this.enterTime = Date.now();
    await this.$nextTick();
    reportPay({
      page_tp: this.page_tp,
      active_tp: 3,
    });
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handlePageUnload);
  },
};
</script>

<style lang="scss" scoped>
.new-user-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.80);
  z-index: 1000;
}
.new-user {
  position: relative;
  margin: 50px auto 0;
  width: 540px;
  height: 850px;
  background: url('https://qncweb-back1.ktvsky.com/20210607/vadd/17db655b455e16cb2ad63e753721d225.png') no-repeat;
  background-size: 100% auto;
  background-position: 0 200px;
  padding-top: 53vw;
}
.swiper-wrappper {
  width: 480px;
  margin: 0 auto;
  ::v-deep .swiper-slide{
      padding: 0px 20px;
  }
  .swiper-pagination {
    position: initial;
    ::v-deep .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #221010;
      margin: 0 6px;
      &-active {
        background: #3b1d1d;
      }
    }
  }
}
.openvip {
  width: 306px;
  height: 74px;
  background: url('https://qncweb-back1.ktvsky.com/20210607/vadd/771001da2466a9848418080e729e6a3f.png') no-repeat;
  background-size: 100% 100%;
  margin: 82px auto 0;
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}
</style>
